import * as types from '../constants'
import callAPI from '../callAPI/callAPI'

export const getAllContact = (contacts) => {
    return {
        type: types.GET_ALL_CONTACT,
        payload: contacts
    }
}

export const fetchAPIAllContact = () => {
    return dispatch => {
        return callAPI('contact', 'GET', null).then(res => {
            dispatch(getAllContact(res.data))
        })
    }
}